export { default } from './CustomPrismicHeading';
